import {
  createContext,
  memo,
  ReactNode,
  useCallback,
  useContext,
  useState,
} from "react";

interface AiSlidePanelContextValue {
  isOpen: boolean;
  open: () => void;
  close: () => void;
  toggle: () => void;
}

const AiSlidePanelContext = createContext<AiSlidePanelContextValue | undefined>(
  undefined,
);

export const AiSlidePanelProvider = memo(function AiSlidePanelProvider({
  children,
}: {
  children: ReactNode;
}) {
  const [isOpen, setIsOpen] = useState(false);

  const open = useCallback(() => {
    setIsOpen(true);
  }, []);

  const close = useCallback(() => {
    setIsOpen(false);
  }, []);

  const toggle = useCallback(() => {
    setIsOpen((prev) => !prev);
  }, []);

  return (
    <AiSlidePanelContext.Provider value={{ isOpen, open, close, toggle }}>
      {children}
    </AiSlidePanelContext.Provider>
  );
});

export function useAiSlidePanel(): AiSlidePanelContextValue {
  const context = useContext(AiSlidePanelContext);
  if (!context) {
    throw new Error(
      "useAiSlidePanel must be used within an AiSlidePanelProvider",
    );
  }
  return context;
}
